<script setup lang="tsx">
const model = defineModel<boolean>({ required: true })
</script>

<template>
	<div class="position-relative d-flex justify-content-center loading" :class="{ active: model }">
		<slot></slot>

		<Transition>
			<div v-if="model" class="position-absolute">
				<div class="spinner-border text-primary"></div>
			</div>
		</Transition>
	</div>
</template>

<style lang="sass" scoped>
.v-enter-active,
.v-leave-active,
.loading
  transition: opacity .3s ease

.v-enter-from,
.v-leave-to
  opacity: 0

.active
  opacity: .6

.spinner-border
  zoom: 2
</style>
